import {
  Building2,
  BriefcaseMedical,
  ClipboardList,
  FileCheck2,
  FileText,
  Home,
  LayoutDashboard,
  LogOut,
  Menu,
  ShieldCheck,
  UserRound,
  Users,
  WalletCards,
  X,
} from "lucide-react";

import {
  useEffect,
  useState,
} from "react";

import {
  NavLink,
  Outlet,
  useNavigate,
} from "react-router-dom";

import "./FacilityLayout.css";

function FacilityLayout() {
  const navigate = useNavigate();

  const [
    sidebarOpen,
    setSidebarOpen,
  ] = useState(false);

  const [
    user,
    setUser,
  ] = useState(null);

  useEffect(() => {
    try {
      const storedUser =
        localStorage.getItem(
          "zethUser"
        );

      const token =
        localStorage.getItem(
          "zethAuthToken"
        );

      if (
        !storedUser ||
        !token
      ) {
        navigate(
          "/facility/login",
          {
            replace: true,
          }
        );

        return;
      }

      const parsedUser =
        JSON.parse(
          storedUser
        );

      if (
        parsedUser?.role !==
        "facility"
      ) {
        navigate(
          "/facility/login",
          {
            replace: true,
          }
        );

        return;
      }

      setUser(
        parsedUser
      );
    } catch (error) {
      console.error(
        "Facility layout auth error:",
        error
      );

      navigate(
        "/facility/login",
        {
          replace: true,
        }
      );
    }
  }, [
    navigate,
  ]);

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  const handleLogout = () => {
    localStorage.removeItem(
      "zethAuthToken"
    );

    localStorage.removeItem(
      "zethUser"
    );

    sessionStorage.removeItem(
      "zethAuthToken"
    );

    sessionStorage.removeItem(
      "zethUser"
    );

    navigate(
      "/facility/login",
      {
        replace: true,
      }
    );
  };

  const navItems = [
    {
      label: "Dashboard",
      to: "/facility/dashboard",
      icon: LayoutDashboard,
    },

    {
      label: "Staffing Requests",
      to: "/facility/staffing-requests",
      icon: ClipboardList,
      disabled: true,
    },

    {
      label: "Assignments",
      to: "/facility/assignments",
      icon: BriefcaseMedical,
      disabled: true,
    },

    {
      label: "Professionals",
      to: "/facility/professionals",
      icon: Users,
      disabled: true,
    },

    {
      label: "Contacts",
      to: "/facility/contacts",
      icon: UserRound,
      disabled: true,
    },

    {
      label: "Contracts",
      to: "/facility/contracts",
      icon: FileText,
      disabled: true,
    },

    {
      label: "Documents",
      to: "/facility/documents",
      icon: FileCheck2,
      disabled: true,
    },

    {
      label: "Billing",
      to: "/facility/billing",
      icon: WalletCards,
      disabled: true,
    },

    {
      label: "Facility Profile",
      to: "/facility/profile",
      icon: Building2,
      disabled: true,
    },
  ];

  return (
    <div className="facility-layout">
      <aside
        className={`facility-sidebar ${
          sidebarOpen
            ? "open"
            : ""
        }`}
      >
        <div className="facility-sidebar-header">
          <button
            type="button"
            className="facility-brand"
            onClick={() =>
              navigate(
                "/facility/dashboard"
              )
            }
          >
            <span className="facility-brand-icon">
              <ShieldCheck
                size={24}
              />
            </span>

            <span>
              <strong>
                Zeth Health
              </strong>

              <small>
                Facility Portal
              </small>
            </span>
          </button>

          <button
            type="button"
            className="facility-sidebar-close"
            onClick={
              closeSidebar
            }
            aria-label="Close navigation"
          >
            <X size={22} />
          </button>
        </div>

        <nav className="facility-sidebar-nav">
          {navItems.map(
            ({
              label,
              to,
              icon: Icon,
              disabled,
            }) => {
              if (disabled) {
                return (
                  <div
                    key={label}
                    className="facility-nav-link disabled"
                  >
                    <Icon
                      size={19}
                    />

                    <span>
                      {label}
                    </span>

                    <small>
                      Soon
                    </small>
                  </div>
                );
              }

              return (
                <NavLink
                  key={label}
                  to={to}
                  onClick={
                    closeSidebar
                  }
                  className={({
                    isActive,
                  }) =>
                    `facility-nav-link ${
                      isActive
                        ? "active"
                        : ""
                    }`
                  }
                >
                  <Icon
                    size={19}
                  />

                  <span>
                    {label}
                  </span>
                </NavLink>
              );
            }
          )}
        </nav>

        <div className="facility-sidebar-bottom">
          <button
            type="button"
            className="facility-nav-home"
            onClick={() =>
              navigate("/")
            }
          >
            <Home
              size={18}
            />

            Home
          </button>

          <div className="facility-sidebar-user">
            <div className="facility-user-avatar">
              {(
                user?.firstName?.[0] ||
                user?.facilityName?.[0] ||
                "F"
              ).toUpperCase()}
            </div>

            <div>
              <strong>
                {user?.facilityName ||
                  user?.firstName ||
                  "Facility"}
              </strong>

              <span>
                {user?.email ||
                  "facility@zethhealth.ca"}
              </span>
            </div>
          </div>

          <button
            type="button"
            className="facility-sidebar-logout"
            onClick={
              handleLogout
            }
          >
            <LogOut
              size={18}
            />

            Sign Out
          </button>
        </div>
      </aside>

      {sidebarOpen && (
        <button
          type="button"
          className="facility-sidebar-overlay"
          onClick={
            closeSidebar
          }
          aria-label="Close navigation"
        />
      )}

      <div className="facility-layout-main">
        <header className="facility-mobile-header">
          <button
            type="button"
            className="facility-mobile-menu"
            onClick={() =>
              setSidebarOpen(
                true
              )
            }
            aria-label="Open navigation"
          >
            <Menu
              size={23}
            />
          </button>

          <strong>
            Zeth Health Facility
          </strong>
        </header>

        <div className="facility-layout-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default FacilityLayout;